import { configureStore } from "@reduxjs/toolkit";
import UISlice from "./ui-slice"
import courseSlice from "./course-store/course-slice";
import categorySlice from "./categories-store/categories-slice";
import userSlice from "./auth-store/auth-slice";
import chargeSlice from "./charge-store/charge-slice";
import departmentSlice from "./department-store/department-slice";
import companiesSlice from "./company-store/company-slice";
import ordenSlice from "./orden-store/orden-slice";
import fileSlice from "./file-slice";
import discountSlice from "./discount-store/discount-slice";


const store = configureStore({
  reducer: {
    ui: UISlice.reducer,
    course: courseSlice.reducer,
    category: categorySlice.reducer,
    auth: userSlice.reducer,
    charge: chargeSlice.reducer,
    department: departmentSlice.reducer,
    company: companiesSlice.reducer,
    orden: ordenSlice.reducer,
    file: fileSlice.reducer,
    discount: discountSlice.reducer,
  },
});

export default store;
